import Vue from 'vue'

const state = {
    // 
}

const getters = {
    // 
}

const actions = {
    planningSequenceRequest: async ({commit}, queries) => {
        let url = `/api/planning/sequence/${queries.workshop_id}/${queries.weekNumber}/${queries.year}`;

        return new Promise((resolve, reject) => {
            Vue.axios.get(url)
                .then(result => {
                    resolve(result.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
}

const mutations = {
    // 
}

export default {
    state,
    getters,
    actions,
    mutations,
}